exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rta{position:relative}.rta .loading{border:solid 1px #ddd;background:#eee;padding:5px 10px}.rta .rta__autocomplete{position:absolute;margin-top:10px;margin-left:3px}.rta .rta__autocomplete ul{list-style-type:none;border:solid 1px #ccc;background:#eee;padding:0;width:200px}.rta .rta__autocomplete ul .rta__entity{padding:2px;border-bottom:solid 1px #ccc;width:100%}.rta .rta__autocomplete ul .rta__entity.rta__entity--selected{color:#fff;background:#4095bf;cursor:default}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./modules/recipe_form/css/smart-text-box.scss
// module id = 667
// module chunks = 0